<a [href]="pubE?.link" target="_blank">
  <img  *ngIf="pubE?.imageName" [src]="publiciteImageUri + pubE?.imageName" width="100%" alt="Pub E" [title]="pubE?.titre" />
  <!--<img  *ngIf="!pubE?.imageName" src="assets/img/logo/pub1.png" width="100%" alt="Pub E" title="Pub E" />-->
</a>
